
import Vue, { PropType } from 'vue';
import Button from '@/components/Button/index.vue';
import Heading from '@/components/Heading/index.vue';
import IconButton from '@/components/IconButton/index.vue';
import { RouterProps } from '@/config/types';
import Bradcrumb from '../Bradcrumb/index.vue';
import Wrapper from './styles';

export default Vue.extend({
  name: 'HeaderInternal',
  components: {
    Button,
    Heading,
    IconButton,
    Wrapper,
    Bradcrumb,
  },
  props: {
    showButton: {
      type: Boolean,
      default: true,
    },
    showPenaltyPageButton: {
      type: Boolean,
      default: false,
    },
    penaltyPageButton: {
      type: Boolean,
      default: false,
    },
    showGeneratePenaltyButton: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    routes: {
      type: Array as PropType<RouterProps[]>,
      required: false,
    },
  },
  methods: {
    goBack(): void {
      this.$router.back();
    },
  },
});
